export const getDestinationOptions = (t) => [
  { value: 'matadero', label: t('admin.event.destination_slaughterhouse') },
  { value: 'venta_directa', label: t('admin.event.destination_direct_sale') },
  { value: 'desvieje', label: t('admin.event.destination_culling') },
  { value: 'otro', label: t('admin.event.destination_other') }
]